import React, { useState, useEffect } from 'react';
import { Form, Input, Button, message, Select} from 'antd';
import { loginRequest } from '../../authConfig';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';

interface ImageCategoryProps {
  imgcategoryid: string;
}

const ImageCategory: React.FC<ImageCategoryProps> = ({imgcategoryid}) => {
  const [CategoryName, setImageCategory] = useState('');
  const [items, setImageTypeData] = useState<[]>([]);
  const [selectedItem, setSelectedImageType] = useState('');
  const { instance, accounts } = useMsal();

  const API_URL = process.env.REACT_APP_API_URL;

  const fetchToken = async () => {
        const res = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0]
        });
        return res.idToken;
      };
    
      useEffect(() => {
        fetchToken();
        getImageTypeData();
        handleLoadData();
      }, []);
      

  const handleSubmit = async () => {
    if (!CategoryName || !selectedItem) {
      message.error('Please fill in all fields');
      return;
    }   

    const letter_only = /^[a-zA-Z]*$/;
    if (!letter_only.test(CategoryName)) 
    {
      message.error('Please enter only letters in the Image Category Name field');
      return;
    }
    const userId = localStorage.getItem("UserId");

  // Map jsonData to the expected format and validate required fields
    const mappedData = {
        ImageCategoryName: CategoryName,
        ImageTypeId: selectedItem,
        CreatedBy: userId
    };

    try {
      const token = await fetchToken();
      if(imgcategoryid === ""){
        await axios.post(`${API_URL}/api/ImageCategory/SaveImageCategory`, mappedData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          });
          message.success('Image Category added successfully');
          setImageCategory('');
          setSelectedImageType('');
      }
      else{
        // Map jsonData to the expected format and validate required fields
        const updatedData = {
            ImageCategoryName: CategoryName,
            ImageTypeId: selectedItem,
            UpdatedBy: userId,
            ImageCategoryId: imgcategoryid
        };

        await axios.put(`${API_URL}/api/ImageCategory/UpdateImageCategory`, updatedData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          });
          message.success('Image Category updated successfully');
          setImageCategory('');
          setSelectedImageType('');
      }
    } catch (error) {
      message.error('Failed to save the data');
    }
  };

  const handleLoadData = async () => {
    if(imgcategoryid === "") return;
    try {
      const token = await fetchToken();
      const response = await axios.get(`${API_URL}/api/ImageCategory/GetImageCategoryById/${imgcategoryid}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });
      setImageCategory(response.data.imageCategoryName);
      setSelectedImageType(response.data.imageTypeId);
    } catch (error) {
      message.error('Failed to load image category data');
    }
  }

  const handleSelectedChange = (value: string) => {
    setSelectedImageType(value);
  }

  const getImageTypeData = async () => {
    try {
      const token = await fetchToken();
      const response = await axios.get(`${API_URL}/api/ImageCategory/GetImageTypeName`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });
      
      setImageTypeData(response.data);
    } catch (error) {
      message.error('Failed to load image type data');
    }
  }

  return (
    <Form layout="vertical" onFinish={handleSubmit}>
      <Form.Item label="Image Type Name" required>
        <Select
          value={selectedItem}
          onChange={handleSelectedChange}
          placeholder="Select"
        >
            {items.map((type: any) => (
              <option key={type.value} value={type.value}>
                {type.text}
              </option>
            ))}
        </Select>
      </Form.Item>
      <Form.Item label="Image Category Name" required>
        <Input
          value={CategoryName}
          onChange={(e) => setImageCategory(e.target.value)}
          placeholder="Enter image category name" maxLength={50}
        />
      </Form.Item>
      
      <Form.Item>
        <Button type="primary" htmlType="submit">
          Save
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ImageCategory;